// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"fzGYFg13","ButtonSkeleton":"DZ4LHH24","IconPlaceholder":"kQYSXnTy","NativeInput":"kAdjZJh4"};